import {Injectable} from '@angular/core';
import {
  ConfigService,
  IntercomService,
  SentryService,
  SessionService,
  User
} from '@q9elements/ui-kit/common';
import {switchMap} from 'rxjs/operators';

import {FirebaseAbstractService} from '@q9elements/ui-kit/refmodels';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private firebaseSvc: FirebaseAbstractService,
    private intercomService: IntercomService,
    private sentryService: SentryService,
    private sessionService: SessionService
  ) {}

  fetchUser(refModelId: string) {
    const url = `${ConfigService.environment.API_ENDPOINT}/refmodel/${refModelId}/account`;

    return this.sessionService.startSession(url).pipe(
      switchMap(async user => {
        await this.firebaseSvc.authenticate(user.firebaseToken);

        this.sentryService.setContext(user);
        this.intercomService.bootIntercom(user);

        return user;
      })
    );
  }
}
